/**
 * @file: screens.tsx
 *
 * The inbox navigator's screen map + derived param types. Screens are
 * referenced directly from their owning flow (feed / chat) — the inbox no
 * longer wraps them; each flow exports its own navigator screen.
 *
 * A conversation is NOT here: the chat room is a full-screen surface pushed on
 * the root stack (`_chat` → `ChatFlow`), because the bottom tab bar under this
 * stack would sit beneath the composer. Open it with `useOpenChatConversation`.
 */

import { ChatSearchScreen } from '@euler/app/flows/chat/pages/search';
import { ArchivedFeedThreadsScreen } from '@euler/app/flows/feed/pages/archived';
import { FeedThreadScreen } from '@euler/app/flows/feed/pages/thread';
import { ScreenToParams } from '@euler/functions/spreadScreens';
import { InboxIndexScreen } from './pages';
import { NotificationSettingsScreen } from './pages/settings';

export const Screens = {
  _index: InboxIndexScreen,
  _feedThread: FeedThreadScreen,
  _archivedFeed: ArchivedFeedThreadsScreen,
  _chatSearch: ChatSearchScreen,
  _settings: NotificationSettingsScreen,
};

export type InboxNavParams = ScreenToParams<typeof Screens>;
